import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GeneralJournalDocumentTemplateLine  {
    _originalTypeClassName = "zERP.BO.GeneralJournalDocumentTemplateLine";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GeneralJournalDocumentTemplateLine.translate = translateService;
}
this.Entries = [];
this.FilledLines = [];
this.Id = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Ledger:any;
Entries:any;
FilledLines:any;
static setLedger = ($this, value) => {
var oldValue = $this.Ledger;
$this.Ledger = value;
if (value != null) {
}
}
static setEntries = ($this, items) => {
                if (items == null) items = [];
                if ($this.Entries == null) $this.Entries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Entries.length > 0) {
                    Domain.GeneralJournalDocumentTemplateLine.removeEntries($this, $this.Entries[0]);
                }

                Domain.GeneralJournalDocumentTemplateLine.addManyEntries($this, copyItems);
            }
static addManyEntries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GeneralJournalDocumentTemplateLine.addEntries($this, items[i]);
                }
            }
static addEntries = ($this, item) => {
                if ($this.Entries == null) $this.Entries = [];
                if (item == null || $this.Entries.indexOf(item) > -1) return;
                $this.Entries.push(item);
}
static addRangeEntries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GeneralJournalDocumentTemplateLine.addEntries($this, item));
            }
static removeEntries = ($this, item) => {
                if ($this == null || $this.Entries == null || $this.Entries.indexOf(item) === -1) return;
                var _index = $this.Entries.indexOf(item);
                $this.Entries.splice(_index, 1);
}
static clearEntries = ($this) => { $this.Entries = null; }
static setFilledLines = ($this, items) => {
                if (items == null) items = [];
                if ($this.FilledLines == null) $this.FilledLines = [];

                const copyItems = Common.cloneObject(items);

                while ($this.FilledLines.length > 0) {
                    Domain.GeneralJournalDocumentTemplateLine.removeFilledLines($this, $this.FilledLines[0]);
                }

                Domain.GeneralJournalDocumentTemplateLine.addManyFilledLines($this, copyItems);
            }
static addManyFilledLines = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GeneralJournalDocumentTemplateLine.addFilledLines($this, items[i]);
                }
            }
static addFilledLines = ($this, item) => {
                if ($this.FilledLines == null) $this.FilledLines = [];
                if (item == null || $this.FilledLines.indexOf(item) > -1) return;
                $this.FilledLines.push(item);
}
static addRangeFilledLines = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GeneralJournalDocumentTemplateLine.addFilledLines($this, item));
            }
static removeFilledLines = ($this, item) => {
                if ($this == null || $this.FilledLines == null || $this.FilledLines.indexOf(item) === -1) return;
                var _index = $this.FilledLines.indexOf(item);
                $this.FilledLines.splice(_index, 1);
}
static clearFilledLines = ($this) => { $this.FilledLines = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}